import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SectionHeading from '@/components/base/SectionHeading';
import ArticleCard from '@/components/base/ArticleCard';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import { useSeo } from '@/hooks/useSeo';
import { getHotArticles, getLatestArticles, getArticlesByCategory, formatViews } from '@/utils/article';

export default function Home() {
  useSeo({
    title: '黑料网曝大瓜-最新明星八卦与娱乐新闻资讯平台',
    description: '黑料网曝大瓜提供丰富的明星绯闻和娱乐圈爆料，涵盖最新新闻动态和热门话题，帮助用户及时了解娱乐八卦信息。',
    keywords: '黑料网曝大瓜,娱乐新闻,明星八卦,娱乐爆料,明星绯闻,娱乐资讯,八卦新闻',
  });

  const heroSlides = getHotArticles(4);
  const latest = getLatestArticles(6);
  const hotList = getHotArticles(6);
  const topics = getArticlesByCategory('topic').slice(0, 3);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />

      <main className="w-full">
        {/* Hero */}
        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 pt-6">
          <HeroCarousel slides={heroSlides} />
        </section>

        {/* Category entries */}
        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 pt-12">
          <SectionHeading eyebrow="Browse" title="分类快捷入口" />
          <CategoryEntries />
        </section>

        {/* Latest + hot */}
        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 pt-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <SectionHeading eyebrow="Latest" title="最新内容" moreTo="/category/news" />
              <div className="flex flex-col gap-3">
                {latest.map((a) => (
                  <ArticleCard key={a.id} article={a} variant="list" />
                ))}
              </div>
              {latest.length === 0 && (
                <p className="text-sm text-foreground-500 py-10 text-center">暂无相关文章，请稍后再来</p>
              )}
            </div>

            <aside className="lg:col-span-1">
              <SectionHeading eyebrow="Hot" title="热门推荐" />
              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="flex items-center gap-2 mb-4 pb-4 border-b border-background-200">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className="ri-fire-line" />
                  </span>
                  <span className="font-heading font-semibold text-sm text-foreground-950">今日热榜</span>
                  <span className="ml-auto text-[11px] text-foreground-400">实时更新</span>
                </div>
                <div className="flex flex-col gap-4">
                  {hotList.map((a, i) => (
                    <ArticleCard key={a.id} article={a} variant="compact" index={i} />
                  ))}
                </div>
              </div>

              {hotList[0] && (
                <Link
                  to={`/detail/${hotList[0].id}`}
                  className="group mt-6 block relative rounded-lg overflow-hidden border border-background-200"
                >
                  <div className="w-full h-44 overflow-hidden bg-background-200">
                    <img
                      src={hotList[0].cover}
                      alt={hotList[0].title}
                      title={`${hotList[0].title} - 黑料网曝大瓜`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <span className="inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium mb-2">
                      <i className="ri-flashlight-line" /> 编辑精选
                    </span>
                    <h3 className="font-heading font-semibold text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {hotList[0].title}
                    </h3>
                    <p className="mt-2 text-xs text-foreground-500 line-clamp-2">{hotList[0].summary}</p>
                    <div className="mt-3 flex items-center gap-3 text-[11px] text-foreground-400">
                      <span className="flex items-center gap-1"><i className="ri-eye-line" /> {formatViews(hotList[0].views)}</span>
                      <span className="flex items-center gap-1"><i className="ri-chat-3-line" /> {formatViews(hotList[0].comments)}</span>
                    </div>
                  </div>
                </Link>
              )}
            </aside>
          </div>
        </section>

        {/* Topic collections */}
        <section className="w-full mt-16 bg-background-100 border-y border-background-200">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-14">
            <SectionHeading eyebrow="Collections" title="专题合集" moreTo="/category/topic" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {topics.map((a, i) => (
                <Link
                  key={a.id}
                  to={`/detail/${a.id}`}
                  className="group relative rounded-lg overflow-hidden border border-background-200 bg-background-50"
                >
                  <div className="w-full h-40 overflow-hidden bg-background-200">
                    <img
                      src={a.cover}
                      alt={a.title}
                      title={`${a.title} - 黑料网曝大瓜`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <span className={`inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full font-medium mb-2 ${i === 1 ? 'bg-secondary-100 text-secondary-800' : 'bg-primary-50 text-primary-600'}`}>
                      <i className="ri-bookmark-3-line" /> {a.sub}
                    </span>
                    <h3 className="font-heading font-semibold text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {a.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 line-clamp-2">{a.summary}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16">
          <div className="rounded-xl bg-primary-950 text-background-50 p-8 md:p-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            <div className="md:col-span-2">
              <span className="font-label text-xs tracking-[0.25em] text-secondary-400 uppercase">About Us</span>
              <h2 className="mt-3 font-heading font-extrabold text-2xl md:text-3xl">全网最快吃瓜阵地</h2>
              <p className="mt-4 text-sm md:text-base text-primary-100/80 leading-relaxed max-w-2xl">
                黑料网曝大瓜专注于明星八卦与娱乐爆料资讯，覆盖明星绯闻、最新娱乐动态、热门爆料与深度专题。我们坚持以最快的速度、最清晰的时间线，把每一个瓜讲明白。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link to="/about" className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                  了解我们
                </Link>
                <Link to="/search" className="px-5 py-2.5 rounded-md border border-primary-700 text-background-50 text-sm font-medium hover:bg-primary-900 transition-colors cursor-pointer whitespace-nowrap">
                  搜索大瓜
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { n: '1.2万', l: '收录爆料' },
                { n: '86万', l: '日活跃' },
                { n: '24h', l: '极速更新' },
                { n: '100%', l: '演艺热点' },
              ].map((s) => (
                <div key={s.l} className="rounded-lg bg-primary-900 p-4">
                  <p className="font-heading font-extrabold text-xl text-secondary-400">{s.n}</p>
                  <p className="mt-1 text-xs text-primary-100/70">{s.l}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}